module.exports = __webpack_public_path__ + "img/iconXiTongJueSeLieBiao.132376f8.svg";